import React from "react";
import styled from "styled-components";

import { Device } from "utils/device";
import { CM } from "components/Typography";

const QuoteContent2024 = (props) => {
  return (
    <S.Section {...props}>
      <CM>
        <b>Our brand partners last year |</b>{" "}
        <i>200 tickets • 10 brand partners • 17 speakers</i>
      </CM>
      <S.Paragraph {...props}>
        <S.BoldWrap>“We loved </S.BoldWrap>
        working with AllBright on the Step Forward Summit.{" "}
        <S.BoldWrap>
          The AllBright team were enthusiastic and positive{" "}
        </S.BoldWrap>
        throughout the entire planning process and{" "}
        <S.BoldWrap>the summit itself surpassed our expectations </S.BoldWrap>
        in terms of the <S.BoldWrap>
          diverse and engaged audiences
        </S.BoldWrap>{" "}
        we were able to introduce to the brand.”
      </S.Paragraph>
      <CM>
        <b>Boden |</b> <i>Brand partner for 2023</i>
      </CM>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  padding: 10%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  background-image: url(/images/step-forward/step-forward-light-gradient.png);
  background-repeat: no-repeat;
  background-size: cover;

  @supports not (-webkit-touch-callout: none) {
    background-attachment: fixed;
  }

  @media (min-width: ${Device.tablet}) {
    padding: 5% 20% 5% 10%;
  }
`;

S.Paragraph = styled.p`
  font-size: 2rem;
  line-height: 2.5rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 2.5rem;
    line-height: 3.4rem;
  }
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

export default QuoteContent2024;
